import "./Popup.css"
const green ='rgba(22, 252, 1, 0.4)';
const orange = 'rgba(248, 190, 0, 0.4)';
const red = 'rgba(211, 14, 14, 1)';
function Popup(props){
  var color = props.color;
  if(color === 'orange'){
    color = orange;
  }
  else if(color === 'green'){
    color = green;
  }
  else if(color === 'red'){
    color = red;
  }
  else{
    color = orange;
  }
  return(
    <div id = 'popup' style={{backgroundColor:color}}>
      {props.message}
    </div>
  );
}
export default Popup;